import React from 'react'
import './HeroSection.css'
import '../App.css'

function HeroSection() {
    return (
     <div className="hero-container">
        
     </div>
    )
}

export default HeroSection
